<template>
	<div>

		<div class="container">
			<el-form class='rgs-form animate__animated animate__bounce' v-if="pageFlag=='register'" ref="registerForm" :model="registerForm" :rules="rules">
				<div class="rgs-form2">
					<div class="title">基于Springboot的小区宠物寄养系统的设计与实现注册</p></div>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="zhanghao">
						<div class="label" :class="changeRules('zhanghao')?'required':''">账号：</div>
						<el-input v-model="registerForm.zhanghao"  placeholder="请输入账号" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="mima">
						<div class="label" :class="changeRules('mima')?'required':''">密码：</div>
						<el-input v-model="registerForm.mima" type="password" placeholder="请输入密码" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="mima2">
						<div class="label" :class="changeRules('mima')?'required':''">确认密码：</div>
						<el-input v-model="registerForm.mima2" type="password" placeholder="请再次输入密码" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="xingming">
						<div class="label" :class="changeRules('xingming')?'required':''">姓名：</div>
						<el-input v-model="registerForm.xingming"  placeholder="请输入姓名" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="xingbie">
						<div class="label" :class="changeRules('xingbie')?'required':''">性别：</div>
						<el-select v-model="registerForm.xingbie" placeholder="请选择性别" >
							<el-option
								v-for="(item,index) in yonghuxingbieOptions"
								:key="index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="shouji">
						<div class="label" :class="changeRules('shouji')?'required':''">手机：</div>
						<el-input v-model="registerForm.shouji"  placeholder="请输入手机" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="touxiang">
						<div class="label" :class="changeRules('touxiang')?'required':''">头像：</div>
						<file-upload
							tip="点击上传头像"
							action="file/upload"
							:limit="1"
							:multiple="true"
							:fileUrls="registerForm.touxiang?registerForm.touxiang:''"
							@change="yonghutouxiangUploadChange"
						></file-upload>
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='yonghu'" prop="dizhi">
						<div class="label" :class="changeRules('dizhi')?'required':''">地址：</div>
						<el-input v-model="registerForm.dizhi"  placeholder="请输入地址" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="gonghao">
						<div class="label" :class="changeRules('gonghao')?'required':''">工号：</div>
						<el-input v-model="registerForm.gonghao"  placeholder="请输入工号" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="mima">
						<div class="label" :class="changeRules('mima')?'required':''">密码：</div>
						<el-input v-model="registerForm.mima" type="password" placeholder="请输入密码" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="mima2">
						<div class="label" :class="changeRules('mima')?'required':''">确认密码：</div>
						<el-input v-model="registerForm.mima2" type="password" placeholder="请再次输入密码" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="yuangongxingming">
						<div class="label" :class="changeRules('yuangongxingming')?'required':''">员工姓名：</div>
						<el-input v-model="registerForm.yuangongxingming"  placeholder="请输入员工姓名" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="yuangongshouji">
						<div class="label" :class="changeRules('yuangongshouji')?'required':''">员工手机：</div>
						<el-input v-model="registerForm.yuangongshouji"  placeholder="请输入员工手机" />
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="yuangongtouxiang">
						<div class="label" :class="changeRules('yuangongtouxiang')?'required':''">员工头像：</div>
						<file-upload
							tip="点击上传员工头像"
							action="file/upload"
							:limit="1"
							:multiple="true"
							:fileUrls="registerForm.yuangongtouxiang?registerForm.yuangongtouxiang:''"
							@change="gongzuorenyuanyuangongtouxiangUploadChange"
						></file-upload>
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="xingbie">
						<div class="label" :class="changeRules('xingbie')?'required':''">性别：</div>
						<el-select v-model="registerForm.xingbie" placeholder="请选择性别" >
							<el-option
								v-for="(item,index) in gongzuorenyuanxingbieOptions"
								:key="index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="list-item" v-if="tableName=='gongzuorenyuan'" prop="zhandianmingcheng">
						<div class="label" :class="changeRules('zhandianmingcheng')?'required':''">站点名称：</div>
						<el-select v-model="registerForm.zhandianmingcheng" placeholder="请选择站点名称" >
							<el-option
								v-for="(item,index) in gongzuorenyuanzhandianmingchengOptions"
								:key="index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<div class="register-btn">
						<div class="register-btn1">
							<el-button class="register_btn" type="primary" @click="submitForm('registerForm')">注册</el-button>
						</div>
						<div class="register-btn2">
							<router-link class="has_btn" to="/login">已有账号，直接登录</router-link>
						</div>
					</div>
				</div>
				<div class="idea1"></div>
				<div class="idea2"></div>
			</el-form>
		</div>
	</div>
</div>
</template>

<script>
	import 'animate.css';

export default {
    //数据集合
    data() {
		return {
            pageFlag : '',
			tableName: '',
			registerForm: {},
			forgetForm: {},
			rules: {},
			requiredRules: {},
            yonghuxingbieOptions: [],
            gongzuorenyuanxingbieOptions: [],
            gongzuorenyuanzhandianmingchengOptions: [],
		}
    },
	mounted() {
		if(this.$route.query.pageFlag=='register'){
			this.tableName = this.$route.query.role;
			if(this.tableName=='yonghu'){
				this.registerForm = {
					zhanghao: '',
					mima: '',
					mima2: '',
					xingming: '',
					xingbie: '',
					shouji: '',
					touxiang: '',
					dizhi: '',
					jifen: Number('0') ,
					sfsh: '',
					shhf: '',
				}
			}
			if(this.tableName=='gongzuorenyuan'){
				this.registerForm = {
					gonghao: '',
					mima: '',
					mima2: '',
					yuangongxingming: '',
					yuangongshouji: '',
					yuangongtouxiang: '',
					xingbie: '',
					zhandianmingcheng: '',
				}
			}
			if ('yonghu' == this.tableName) {
				this.rules.zhanghao = [{ required: true, message: '请输入账号', trigger: 'blur' }];
				this.requiredRules.zhanghao = [{ required: true, message: '请输入账号', trigger: 'blur' }]
			}
			if ('yonghu' == this.tableName) {
				this.rules.mima = [{ required: true, message: '请输入密码', trigger: 'blur' }];
				this.requiredRules.mima = [{ required: true, message: '请输入密码', trigger: 'blur' }]
			}
			this.yonghuxingbieOptions = "男,女".split(',');
			if ('yonghu' == this.tableName) {
				this.rules.shouji = [{ required: true, validator: this.$validate.isMobileNotNull, trigger: 'blur' }];
				this.requiredRules.shouji = [{ required: true, message: '请输入手机', trigger: 'blur' }]
			}
			if ('gongzuorenyuan' == this.tableName) {
				this.rules.yuangongshouji = [{ required: true, validator: this.$validate.isMobile, trigger: 'blur' }];
			}
			this.gongzuorenyuanxingbieOptions = "男,女".split(',');
			this.$http({
				url: `option/jiyangdian/zhandianmingcheng`,
				method: "get",
				params: {}
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.gongzuorenyuanzhandianmingchengOptions = data.data;
				}
			});
		}
	},
    created() {
		this.pageFlag = this.$route.query.pageFlag;
    },
    //方法集合
    methods: {
		changeRules(name){
			if(this.requiredRules[name]){
				return true
			}
			return false
		},
		// 获取uuid
		getUUID () {
			return new Date().getTime();
		},
        // 下二随
		yonghutouxiangUploadChange(fileUrls) {
			this.registerForm.touxiang = fileUrls.replace(new RegExp(this.$config.baseUrl,"g"),"");
		},
		gongzuorenyuanyuangongtouxiangUploadChange(fileUrls) {
			this.registerForm.yuangongtouxiang = fileUrls.replace(new RegExp(this.$config.baseUrl,"g"),"");
		},

		// 多级联动参数


		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var url=this.tableName+"/register";
					if(this.tableName=='yonghu'){
						this.registerForm.sfsh = '待审核'
					}
					if(`yonghu` == this.tableName && this.registerForm.mima!=this.registerForm.mima2) {
						this.$message.error(`两次密码输入不一致`);
						return
					}
					if(`gongzuorenyuan` == this.tableName && this.registerForm.mima!=this.registerForm.mima2) {
						this.$message.error(`两次密码输入不一致`);
						return
					}
					this.$http.post(url, this.registerForm).then(res => {
						if (res.data.code === 0) {
							this.$message({
								message: '注册成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.$router.push('/login');
								}
							});
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.container {
		background: url(http://codegen.caihongy.cn/20241210/2ed71b328b23423aa9720217d4a1d455.webp) no-repeat center top / cover;
		display: flex;
		width: 100%;
		min-height: 100vh;
		justify-content: center;
		align-items: center;
		position: relative;
		background: url(http://codegen.caihongy.cn/20241210/2ed71b328b23423aa9720217d4a1d455.webp) no-repeat center top / cover;
		.rgs-form {
			border: 4px solid #FFFFFF;
			border-radius: 10px;
			padding: 0;
			box-shadow: none;
			backdrop-filter: 10px;
			margin: 20px 0;
			z-index: 1;
			background: rgba(255,255,255,0.5);
			width: 681px;
			height: auto;
			.rgs-form2 {
				width: 100%;
				.title {
					margin: 40px 0;
					color: #1F1F1F;
					font-weight: 700;
					width: 100%;
					font-size: 24px;
					line-height: 44px;
					text-align: center;
				}
				.subtitle {
					margin: 0 0 10px 0;
					text-shadow: 4px 4px 2px rgba(64, 158, 255, .5);
					color: rgba(64, 158, 255, 1);
					width: 100%;
					font-size: 20px;
					line-height: 44px;
					text-align: center;
				}
				.list-item {
					margin: 0 auto 10px;
					display: flex;
					width: 505px;
					border-color: #000000;
					border-width: 0 0 1px 0;
					border-style: solid;
					/deep/.el-form-item__content {
						display: flex;
						width: 100%;
						.label {
							color: #000000;
							width: 120px;
							font-size: 14px;
							line-height: 60px;
						}
						
						.required {
							position: relative;
						}
						.required::after{
							color: red;
							left: -10px;
							position: absolute;
							content: "*";
						}
						.el-input {
							width: 100%;
						}
						.el-input .el-input__inner {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-input .el-input__inner:focus {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-input-number {
							width: 100%;
						}
						.el-input-number /deep/ .el-input__inner {
							text-align: left;
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-input-number /deep/ .el-input-number__decrease {
							display: none;
						}
						.el-input-number /deep/ .el-input-number__increase {
							display: none;
						}
						.el-select {
							width: 100%;
						}
						.el-select .el-input__inner {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-select .el-input__inner:focus {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-date-editor {
							width: 100%;
						}
						.el-date-editor .el-input__inner {
							border: none;
							padding: 0 40px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-date-editor .el-input__inner:focus {
							border: none;
							padding: 0 40px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-upload--picture-card {
							background: transparent;
							border: 0;
							border-radius: 0;
							width: auto;
							height: auto;
							line-height: initial;
							vertical-align: middle;
						}
						.upload .upload-img {
							border: 1px dashed rgba(64, 158, 255, 1);
							cursor: pointer;
							border-radius: 8px;
							color: #000;
							width: 80px;
							font-size: 32px;
							line-height: 80px;
							text-align: center;
							height: 80px;
						}
						.el-upload-list .el-upload-list__item {
							border: 1px dashed rgba(64, 158, 255, 1);
							cursor: pointer;
							border-radius: 8px;
							color: #000;
							width: 80px;
							font-size: 32px;
							line-height: 80px;
							text-align: center;
							height: 80px;
							font-size: 14px;
							line-height: 1.8;
						}
						.el-upload .el-icon-plus {
							border: 1px dashed rgba(64, 158, 255, 1);
							cursor: pointer;
							border-radius: 8px;
							color: #000;
							width: 80px;
							font-size: 32px;
							line-height: 80px;
							text-align: center;
							height: 80px;
						}
						.el-upload__tip {
							color: #838fa1;
						}
						.emailInput {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.emailInput:focus {
							border: none;
							padding: 0 10px;
							color: #000000;
							background: transparent;
							width: 100%;
							font-size: 14px;
							height: 60px;
						}
						.el-btn {
							border: 0;
							cursor: pointer;
							padding: 0;
							margin: 0;
							color: #fff;
							font-size: 12px;
							border-radius: 0 4px 4px 0;
							box-shadow: none;
							outline: none;
							background: linear-gradient( 135deg, #B1D8FB 0%, #7483E5 55%, #423CD2 100%);
							flex: none;
							width: 80px;
							height: 60px;
						}
						.el-btn:hover {
						}
						
						.el-input__inner::placeholder {
							color: #9E9E9E;
							font-size: 14px;
						}
						input::placeholder {
							color: #9E9E9E;
							font-size: 14px;
						}
						.editor {
							width: 100%;
							height: auto;
						}
					}
				}
				.register-btn {
					margin:  0 auto;
					width: 505px;
				}
				.register-btn1 {
					width: 100%;
				}
				.register-btn2 {
					margin: 20px 0;
					width: 100%;
				}
				.register_btn {
					border: 0;
					cursor: pointer;
					border-radius: 4px;
					padding: 0;
					margin: 0;
					outline: none;
					color: #fff;
					background: linear-gradient( 135deg, #B1D8FB 0%, #7483E5 55%, #423CD2 100%);
					width: 100%;
					font-size: 24px;
					height: 60px;
				}
				.register_btn:hover {
				}
				.has_btn {
					border: 0;
					cursor: pointer;
					padding: 0;
					margin: 0;
					color: #000;
					display: inline-block;
					text-decoration: none;
					font-size: 14px;
					line-height: 60px;
					border-radius: 4px;
					outline: none;
					background: #FFF;
					width: 100%;
					text-align: center;
					height: 60px;
				}
				.has_btn:hover {
				}
			}
			.idea1 {
				background: red;
				display: none;
				width: 100%;
				height: 40px;
			}
			.idea2 {
				background: blue;
				display: none;
				width: 100%;
				height: 40px;
			}
		}
	}
	
	::-webkit-scrollbar {
		display: none;
	}
</style>
